import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Col, Row } from "reactstrap"
import { downloadResponsesReport, getAllUserResponses } from "store/actions"
import { getUpdatedCheckedItemsList } from "utils"
import Flatpickr from "react-flatpickr"
import triviaResponsesListColumns from "./triviaResponsesListColumns"
import Select from "react-select"

const UserList = ({
  handleOpenIndividualAnswers,
  allUserResponses,
  getAllUserResponses,
  history,
  feature_id,
  triviaChallenge,
  downloadResponsesReport,
  feature_name,
}) => {
  const [checkedItems, setCheckedItems] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedVisitors, setSelectedVisitors] = useState([])
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [questionValue, setQuestionValue] = useState(null)
  const [answerValue, setAnswerValue] = useState(null)
  const [questionFilterOptions, setQuestionFilterOptions] = useState([])
  const [answerFilterOptions, setAnswerFilterOptions] = useState([])

  useEffect(() => {
    if (triviaChallenge && triviaChallenge?.questions) {
      const questions = []
      for (let question of triviaChallenge.questions) {
        questions.push(question)
      }
      setQuestionFilterOptions(questions)
    }
  }, [triviaChallenge])

  const handleCheckItem = (item, checked) => {
    if (checked) {
      if (
        !item?.guest_id &&
        item?.user_id &&
        selectedUsers?.indexOf(item?.user_id) === -1
      ) {
        setSelectedUsers([...selectedUsers, item?.user_id])
      }

      if (item?.guest_id && selectedVisitors?.indexOf(item?.guest_id) === -1) {
        setSelectedVisitors([...selectedVisitors, item?.guest_id])
      }
    } else {
      if (item?.guest_id) {
        let arr = [...selectedVisitors]
        arr?.splice(arr?.indexOf(item?.guest_id), 1)
        setSelectedVisitors(arr)
      } else {
        let arr = [...selectedUsers]
        arr?.splice(arr?.indexOf(item?.user_id), 1)
        setSelectedUsers(arr)
      }
    }

    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    let visitors = []
    let users = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        if (items[i]?.user_id && !items[i]?.guest_id) {
          users.push(items[i]?.user_id)
        }
        if (items[i]?.guest_id) {
          visitors.push(items[i].guest_id)
        }
        list.push(items[i].id)
      }
    }
    setSelectedUsers(users)
    setSelectedVisitors(visitors)
    setCheckedItems(list)
  }

  const handlePageChange = page => {
    getAllUserResponses({
      feature: "trivia",
      page: page,
      per_page: 15,
      feature_id: feature_id,
      od: "desc",
      ...(startDate.trim().length ? { start: startDate } : {}),
      ...(endDate.trim().length ? { end: endDate } : {}),
      ...(answerValue?.value ? { answer_id: answerValue?.value } : {}),
    })
    setCurrentPage(page)
    setCheckedItems([])
    setSelectedUsers([])
    setSelectedVisitors([])
  }

  const searchHanler = () => {
    if (!!endDate || !!startDate) {
      setShowResetButton(true)
    }
    getAllUserResponses({
      feature: "trivia",
      page: 1,
      per_page: 15,
      feature_id: feature_id,
      od: "desc",
      ...(startDate.trim().length ? { start: startDate } : {}),
      ...(endDate.trim().length ? { end: endDate } : {}),
      ...(answerValue?.value ? { answer_id: answerValue?.value } : {}),
    })
  }

  const resetSearchHandler = () => {
    getAllUserResponses({
      feature: "trivia",
      page: 1,
      per_page: 15,
      feature_id: feature_id,
      od: "desc",
    })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
    setAnswerValue(null)
    setQuestionValue(null)
  }

  return (
    <Card>
      <CardBody>
        <Row className="mb-3">
          <Col>
            <h4>User List</h4>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs="auto" className="my-1">
            <Flatpickr
              className="form-control bg-white"
              placeholder="Select Start Date"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              value={startDate}
              onChange={(selectedDates, dateStr) => {
                setStartDate(dateStr)
              }}
            />
          </Col>
          <Col xs="auto" className="my-1">
            <Flatpickr
              className="form-control bg-white"
              placeholder="Select End Date"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              value={endDate}
              onChange={(selectedDates, dateStr) => {
                setEndDate(dateStr)
              }}
            />
          </Col>
          <Col xs="auto" className="my-1">
            <div style={{ width: "200px" }}>
              <Select
                value={questionValue}
                placeholder="Select Question"
                onChange={v => {
                  setShowResetButton(true)
                  setQuestionValue(v)
                  setAnswerValue(null)
                  if (v?.value) {
                    const question = questionFilterOptions?.find(
                      q => q?.id === v?.value
                    )
                    const answers = []
                    for (let answ of question?.answers) {
                      answers.push({ label: answ?.answer, value: answ?.id })
                    }
                    setAnswerFilterOptions(answers)
                  }
                }}
                options={questionFilterOptions?.map(q => ({
                  value: q?.id,
                  label: q?.question,
                }))}
                isSearchable={false}
              />
            </div>
          </Col>
          <Col xs="auto" className="my-1">
            <div style={{ width: "150px" }}>
              <Select
                placeholder="Select Answer"
                value={answerValue}
                onChange={v => {
                  setShowResetButton(true)
                  setAnswerValue(v)
                }}
                options={answerFilterOptions}
                isSearchable={false}
                isDisabled={!questionValue}
              />
            </div>
          </Col>
          <Col xs="auto" className="my-1">
            <SaveButton type="button" content="Filter" onClick={searchHanler} />
          </Col>
          {showResetButton && (
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                content="Reset"
                color="light"
                onClick={resetSearchHandler}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Send Email"
              disabled={selectedUsers?.length === 0}
              onClick={() => {
                localStorage.setItem("commUsers", JSON.stringify(selectedUsers))
                history.push(`/add-custom-email`)
              }}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              content="Send Notification"
              disabled={
                selectedUsers?.length === 0 && selectedVisitors?.length === 0
              }
              onClick={() => {
                localStorage.setItem("commUsers", JSON.stringify(selectedUsers))
                history.push(`/add-notification`)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Download report"
              disabled={allUserResponses?.data?.length === 0}
              onClick={() =>
                downloadResponsesReport({
                  feature: "trivia",
                  feature_id: feature_id,
                  report_name: feature_name + " Report",
                  start: startDate,
                  end: endDate,
                })
              }
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <TableComponent
              data={allUserResponses?.data}
              columns={triviaResponsesListColumns({
                displayAnswersColumn: true,
                openModal: handleOpenIndividualAnswers,
              })}
              withCheckboxes={true}
              onCheckItem={handleCheckItem}
              onCheckAllItems={handleCheckAllItems}
              paginationData={{
                current_page: allUserResponses.current_page,
                last_page: allUserResponses.last_page,
                total_items: allUserResponses.total,
                items_per_page: allUserResponses.per_page,
                from: allUserResponses.from,
                to: allUserResponses.to,
                first_page: 1,
              }}
              onPageChange={handlePageChange}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  allUserResponses: state.Analytics.allUserResponses,
  triviaChallenge: state.TriviaChallenge.triviaChallenge,
})

const mapDispatchToProps = dispatch => ({
  getAllUserResponses: values => dispatch(getAllUserResponses(values)),
  downloadResponsesReport: values => dispatch(downloadResponsesReport(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserList))
